import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useNavigate } from 'react-router-dom';
import { ConfigProvider } from 'antd';
import zhCN from 'antd/locale/zh_CN';
import enUS from 'antd/locale/en_US';
import { useTranslation } from 'react-i18next';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Wizard from './pages/Wizard';
import PortfolioDetail from './pages/PortfolioDetail';
import Test401 from './pages/Test401';
import ApiProvider from './components/ApiProvider';
import './i18n';

// 内部组件，包含路由和导航逻辑
function AppRoutes() {
  const { i18n } = useTranslation();
  const navigate = useNavigate();

  const antdLocale = i18n.language === 'en-US' ? enUS : zhCN;

  return (
    <ConfigProvider locale={antdLocale}>
      <ApiProvider navigate={navigate}>
        <div className="App">
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/wizard" element={<Wizard />} />
            <Route path="/portfolio" element={<PortfolioDetail />} />
            <Route path="/test401" element={<Test401 />} />
            <Route path="/" element={<Navigate to="/login" replace />} />
          </Routes>
        </div>
      </ApiProvider>
    </ConfigProvider>
  );
}

function App() {
  return (
    <Router>
      <AppRoutes />
    </Router>
  );
}

export default App;